// @flow
import xws from 'api/xws/';
import qs from 'query-string';
import type { AxiosPromise } from 'axios';

// Constants
import { getService } from 'constants/ajax';

export type SignUpResponse = {|
  key?: string,
  message: string,
  statusCode: number,
  success: boolean
|};

type RequestData = {|
  tokenId: string,
  webKey: string,
  userName: string,
  password: string,
  confirmationKey: string
|};

export function signUpWS(
  data: RequestData
): AxiosPromise<RequestData, SignUpResponse> {
  const signUpService = getService('signUp');
  return xws(signUpService).post(signUpService.getPath(), qs.stringify(data));
}



// WEBPACK FOOTER //
// ./src/api/xws/signUp/signUpWs.js